module.exports = __webpack_public_path__ + "img/Battle6.83786568.jpg";